import Vue from "vue";

const formatPercent = (value: number | string, decimal = 1): string => {
  value = typeof value === "string" ? parseFloat(value) : value;
  value = (value * 100).toFixed(decimal);
  return `${value}%`;
};

Vue.filter("formatPercent", formatPercent);
